import React from "react";
import { useHistory, Link } from "react-router-dom";
import { useGlobalContext } from "../context";
import Loading from "./Loading";

const LoginPage = ({ admin }) => {
  const { login, logout } = useGlobalContext();
  const [loading, setLoading] = React.useState(false);
  const [identifier, setIdentifier] = React.useState("");
  const [password, setPassword] = React.useState("");
  const history = useHistory();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!identifier || !password) {
      alert("Please enter your username and password.");
      return;
    }
    try {
      setLoading(true);
      await logout();
      await login(identifier.toLocaleLowerCase().trim(), password, admin);
      setLoading(false);
      history.push("/");
    } catch (error) {
      alert("Login failed! please check your username and password.");
      console.log(error);
      setLoading(false);
    }
  }
  return (
    <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4 mt-5 mx-auto">
      <div className="bg-white p-4 shadow rounded border">
        {admin ? (
          <h1 className="display-5 text-muted mt-0">Admin Login</h1>
        ) : (
          <>
            <h5 className="text-center">
              <Link to="/textbooks">PDF Textbooks</Link>
            </h5>
            <h1 className="display-5 text-muted mt-0">Finals Login</h1>
            <p>
              Refer to the Phase 1. Instructions Sheet included in your package
              by mail for login credentials
            </p>
          </>
        )}
        {loading && <Loading />}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="usernameInput" className="form-label">
              Username
            </label>
            <input
              type="text"
              id="usernameInput"
              name="identifier"
              className="form-control"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="passwordInput" className="form-label">
              Password
            </label>
            <input
              type="password"
              id="passwordInput"
              name="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <input
            type="submit"
            className="btn btn-primary w-100"
            value="Login"
          />
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
